import React from 'react'

const GuestWhiteSvg = ({ width }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      viewBox='0 0 26.747 28.084'
    >
      <g id='guest-add-svgrepo-com' transform='translate(-3 -2)'>
        <path
          id='Path_3261'
          data-name='Path 3261'
          d='M16.043,2A3.005,3.005,0,0,1,19.03,4.675h2.358a3.009,3.009,0,0,1,3,2.8l.007.206v6.585a8.72,8.72,0,0,0-2.006-.233V7.684a1,1,0,0,0-.867-.994l-.136-.009H18.537a3,3,0,0,1-2.493,1.327h-4.69A3,3,0,0,1,8.861,6.682H6.009a1,1,0,0,0-.994.867l-.009.136v18.06a1,1,0,0,0,.867.994l.136.009h8.672a8.718,8.718,0,0,0,1.444,2.006H6.009a3.009,3.009,0,0,1-3-2.8L3,25.744V7.684a3.009,3.009,0,0,1,2.8-3l.206-.007H8.367A3,3,0,0,1,11.354,2Zm0,2.006h-4.69a1,1,0,1,0,0,2h4.69a1,1,0,1,0,0-2Z'
          transform='translate(0)'
          fill='#fff'
        />
        <path
          id='Path_3262'
          data-name='Path 3262'
          d='M8.672,14H13.72a8.652,8.652,0,0,0-1.37,4.687,8.763,8.763,0,0,0,.1,1.336h-.1C8.969,20.018,7,18.8,7,16.332v-.665A1.672,1.672,0,0,1,8.672,14Z'
          transform='translate(1.349 4.046)'
          fill='#fff'
        />
        <path
          id='Path_3263'
          data-name='Path 3263'
          d='M11.843,8A3.343,3.343,0,1,1,8.5,11.339,3.343,3.343,0,0,1,11.843,8Z'
          transform='translate(1.855 2.022)'
          fill='#fff'
        />
        <path
          id='Path_3264'
          data-name='Path 3264'
          d='M26.711,19.355a7.355,7.355,0,1,0-7.355,7.355A7.355,7.355,0,0,0,26.711,19.355Zm-6.686.669v3.348a.669.669,0,1,1-1.337,0V20.024H15.338a.669.669,0,0,1,0-1.337h3.349V15.342a.669.669,0,0,1,1.337,0v3.344h3.347a.669.669,0,1,1,0,1.337Z'
          transform='translate(3.036 3.373)'
          fill='#fff'
        />
      </g>
    </svg>
  )
}

export default GuestWhiteSvg
